export default "__VITE_ASSET__94c44404__"